import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { PageHeader } from "./fordon";
import { MODELL_SERIER } from "@/data/modell-serier";

const TITLE = "Modellserier husbil & husvagn – priser, fel och planlösningar";
const DESC =
  "Modellguider för Kabe Royal, Smaragd, Polar Svit, Adria Alpina, Matrix, Hymer Exsis m.fl. Prisspann per årsmodell, vanliga fel och vår kontroll före köp.";

export const Route = createFileRoute("/modeller/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "https://www.akhusbilfritid.se/modeller" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "index, follow, max-image-preview:large" },
    ],
    links: [{ rel: "canonical", href: "https://www.akhusbilfritid.se/modeller" }],
  }),
  component: ModellerIndex,
});

function ModellerIndex() {
  const husbilar = MODELL_SERIER.filter((m) => m.category === "husbil");
  const husvagnar = MODELL_SERIER.filter((m) => m.category === "husvagn");

  const Grid = ({ items }: { items: typeof MODELL_SERIER }) => (
    <div className="mt-8 grid gap-6 md:grid-cols-3">
      {items.map((m) => (
        <Link
          key={`${m.brandSlug}/${m.slug}`}
          to="/modeller/$brand/$serie"
          params={{ brand: m.brandSlug, serie: m.slug }}
          className="group rounded-3xl border border-border bg-card p-6 transition hover:-translate-y-1 hover:shadow-xl"
        >
          <p className="eyebrow">{m.brandName}</p>
          <h3 className="mt-3 font-display text-2xl">{m.name}</h3>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{m.intro.slice(0, 120)}…</p>
          <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-accent">
            Läs modellguiden <ArrowRight size={14} className="transition group-hover:translate-x-0.5" />
          </span>
        </Link>
      ))}
    </div>
  );

  return (
    <>
      <PageHeader
        label="Modellguider"
        title={<>Modellserier vi kan <span className="font-italic-display text-accent">på riktigt</span>.</>}
        sub="Prisspann per årsmodell, planlösningar, vinterduglighet och de fel vi återkommande åtgärdar i verkstaden i Kalix."
      />
      <section className="container-edge py-14 md:py-20">
        <p className="eyebrow">Husvagnar</p>
        <h2 className="mt-3 font-display text-3xl md:text-4xl">Husvagnsserier.</h2>
        <Grid items={husvagnar} />

        <p className="eyebrow mt-16">Husbilar</p>
        <h2 className="mt-3 font-display text-3xl md:text-4xl">Husbilsserier.</h2>
        <Grid items={husbilar} />
      </section>
    </>
  );
}
